export default "__VITE_ASSET__pwORFOeV__"